var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.position
    ? _c(
        "div",
        { staticClass: "hotel-map" },
        [
          _c(
            "GmapMap",
            {
              staticStyle: { width: "100%", height: "100%" },
              attrs: { center: _vm.position, zoom: 15 }
            },
            [
              _c("GmapMarker", { attrs: { position: _vm.position } }),
              _vm._v(" "),
              _c(
                "gmap-info-window",
                {
                  attrs: {
                    options: _vm.infoOptions,
                    position: _vm.position,
                    opened: true
                  }
                },
                [
                  _c("h2", {
                    staticClass: "hotel-map__title",
                    domProps: { textContent: _vm._s(_vm.hotelName) }
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ea1d83c", { render: render, staticRenderFns: staticRenderFns })
  }
}